import type { IEnv } from '../../utils/utils'

export const env: IEnv = (window as any).$$env
